import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from "@mui/material/Box";
import MpgInput from "../../../../../CommonFormComp/MpgInput";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { v4 as uuidv4 } from 'uuid';
import { useGetLoggedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import FormHelperText from '@mui/material/FormHelperText';
import sortBy from "lodash/sortBy";
import { useOutletContext } from 'react-router-dom';

const EditFolderActionDialog = ({ open, setOpen, compositeFolderArrayInsideRoot, setCompositeFolderArrayInsideRoot, parentItemObjData, setParentItemObjData, targetItemObjData, setTargetItemObjData }) => {

    const { loggedInUser } = useGetLoggedInUserDetails();
    const { emailAddress } = loggedInUser;

    /**
    * parentItemObjData gives complete folder data object for computation
    */

    // console.log("compositeFolderArrayInsideRoot-parentItemObjData-IN", parentItemObjData)

    useEffect(() => {
        if (!!open) {
            setOpen(true)
        } else {
            setOpen(false)
        }
    }, [open])

    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }

        setParentItemObjData({})
        setTargetItemObjData({})
    };

    const schema = yup.object().shape({
        folder_name: yup.string().label('This field').required().max(50),
    });

    const rhfFormInstanceForPDFolderEdit = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            folder_name: "",
        },
    });

    const { setValue, reset, watch } = rhfFormInstanceForPDFolderEdit

    const inputFolderName = watch("folder_name")
    /** populate folder name in the form */
    useEffect(() => {
        if (!!parentItemObjData) {
            setValue("folder_name", parentItemObjData?.ResourceFolderName)
        }
    }, [parentItemObjData])

    /**folder name validation */

    /**folder name validation. at same level same name is not allowed. */
    let arrayOfOnlyFolderNames = []

    /**folder count validation. max 20 folders are allowed to create. */
    let folders = !!compositeFolderArrayInsideRoot && compositeFolderArrayInsideRoot.filter((eachFolder) => {
        if (eachFolder?.Id !== parentItemObjData?.Id) {
            if (!eachFolder?.IsDeleted) {
                arrayOfOnlyFolderNames.push(eachFolder?.ResourceFolderName)
                return eachFolder?.Id
            }
        }
    })
    const [errorMsg, setErrorMsg] = useState("")
    useEffect(() => {
        /**folder name validation. at same level same name is not allowed. */
        if (!!arrayOfOnlyFolderNames.includes(inputFolderName?.trim())) {
            const foldersNameMsg = "This folder name exists at this level."
            setErrorMsg(foldersNameMsg)
        }
        else {
            setErrorMsg("")
        }
    }, [arrayOfOnlyFolderNames, inputFolderName, folders])
    /**disabling submit on failing custom validations */
    const [disableSubmitButton, setDisableSubmitButton] = useState(false)
    useEffect(() => {
        if (!!arrayOfOnlyFolderNames.includes(inputFolderName?.trim())) {
            setDisableSubmitButton(true)
        } else {
            setDisableSubmitButton(false)
        }
    }, [folders, arrayOfOnlyFolderNames, inputFolderName])

    const onSubmitForPDFolderEdit = (data, e) => {

        const editedFolderName = data?.folder_name

        /**index is required as we want to insert excludedItem at same index in array later. Beacause if we try to merge item into array then it creates that entry at the end of the array. To avoid this and to maintain same position, we need this index to be used in splice method */
        let indexOfExcludedTreeItem = '' /**must be in string */
        let excludedTreeItem = {}
        const arrayWithoutExcludedTreeItem = !!compositeFolderArrayInsideRoot && compositeFolderArrayInsideRoot.filter((eachItem, index) => {

            if (eachItem?.Id !== parentItemObjData?.Id) {
                return eachItem
            } else {
                indexOfExcludedTreeItem = `${index}`
                excludedTreeItem = eachItem
            }

        })

        /**
        *
        */
        const editedItem = {
            ...excludedTreeItem,
            ResourceFolderName: editedFolderName,
            UpdatedBy: emailAddress || ""
        }

        if (!!indexOfExcludedTreeItem) {
            const index = Number(indexOfExcludedTreeItem)

            /**
             * Inserting Item at specific index in an array:
             * splice(indexWhereToInsertItem, startFromIndex, NewItemToBeInserted)
             */

            arrayWithoutExcludedTreeItem.splice(index, 0, editedItem);

            /**as splice modifies original array itself,  arrayWithoutExcludedTreeItem after splice contains inserted editedItem at desired index*/

            /**sort folder array*/
            const inputArrayForSorting = arrayWithoutExcludedTreeItem || []

            const sortedFolderArray = sortBy(inputArrayForSorting, function (item) {
                const folderName = item?.ResourceSubFolderName || ""
                /**we are converting all folder names into smallcase for proper aphabetical order */
                return [folderName.toLowerCase()];
            });

            setCompositeFolderArrayInsideRoot(sortedFolderArray || [])

        }

        // console.log("compositeFolderArrayInsideRoot-filter", editedItem)

        reset({ folder_name: "" })

        handleClose()
    };

    const resourcesCMSData = useOutletContext();

    const fetchClientAccResDtlsLabel = (key) => {
        if (resourcesCMSData && resourcesCMSData?.pageContent["ClientAccountResourcesDetails"]) {
          const resourcesCMSDataLabel = resourcesCMSData.pageContent["ClientAccountResourcesDetails"];
          return returnLabel(resourcesCMSDataLabel?.Labels, key)
        }
    }

    const fetchCommonCMSLabel = (key) => {
        if (resourcesCMSData && resourcesCMSData?.pageContent["CommonComponent"]) {
            const commonCMSDataLabel = resourcesCMSData.pageContent["CommonComponent"];
            return returnLabel(commonCMSDataLabel?.Labels, key)
        }
        return '';
    }

    const returnLabel = (labelArray, key) => {
        if (labelArray.length > 0 && key) {
            return labelArray.find((x) => x.Key === key)?.Phrase || '';
        }
        return '';
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Box
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={(e) => {
                    /**  e.stopPropagation(); required to use form within form seperately to avoid conflicts between nested form submits. */
                    e.stopPropagation();
                    rhfFormInstanceForPDFolderEdit.handleSubmit(onSubmitForPDFolderEdit)(e)
                }}
            >
                <DialogTitle>
                    <MpgInput
                        rhfFormInstance={rhfFormInstanceForPDFolderEdit}
                        name={"folder_name"}
                        label={"Folder Name"}
                        fullWidth
                    />
                    {
                        <FormHelperText error={!!errorMsg}>
                            {errorMsg}
                        </FormHelperText>
                    }
                </DialogTitle>
                <DialogContent>

                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            handleClose()
                        }}
                    >
                        {fetchCommonCMSLabel ("Common.Cancel")}
                    </Button>

                    <Button
                        type="submit"
                        disabled={!!disableSubmitButton}
                    >
                        {fetchCommonCMSLabel ("Common.OK")}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    )
}
export default EditFolderActionDialog